import { lazy } from "react";
import { authRoles } from "src/app/roles";

const NavigationEditor = lazy(() => import("./NavigationEditor"));
const FormBuilder = lazy(() => import("./FormBuilder"));
const DevTools = lazy(() => import("./DevTools"));

const toolsRoutes = [
  {
    path: "tools/navigation-editor",
    element: <NavigationEditor />,
    auth: authRoles.editor
  }, 
  {
    path: "tools/form-builder",
    element: <FormBuilder />,
    auth: authRoles.editor
  },
  {
    path: "tools/dev-tools",
    element: <DevTools />,
    auth: authRoles.editor
  }
];

export default toolsRoutes;
